import { flare } from '@flareapp/js';
import { flareVue } from '@flareapp/vue';
import Vue from 'vue';
export default (function (_ref) {
  var flareKey = _ref.$config.flareKey;

  // Only enable Flare in production, we don't want to waste your quota while you're developing:
  if (process.env.NODE_ENV === 'production') {
    flare.light(flareKey);
  }

  Vue.use(flareVue);
});